/** An employee's staff page. */
export function employeePath(vendorId: string, id: string): string {
  return `/staff/employees/${encodeURIComponent(vendorId)}/${encodeURIComponent(id)}`;
}
